import type StaffMemberFilterView from '@UI/Pages/Agencies/StaffMembers/Filters/StaffMemberFilterView';
import type StaffMemberView from '@UI/Store/StaffMembers/Views/StaffMemberView';

/** Pure client-side filter: search (name) ∩ job function ∩ facility. */
const filterStaffMembers = (
	staffMembers: readonly StaffMemberView[],
	filters: StaffMemberFilterView,
): StaffMemberView[] => {
	const normalizedSearch = filters.search.trim().toLowerCase();

	return staffMembers.filter((staffMember) => {
		if (normalizedSearch.length > 0 && !staffMember.fullName.toLowerCase().includes(normalizedSearch)) {
			return false;
		}

		if (filters.jobFunction !== null && staffMember.jobFunction.value !== filters.jobFunction) {
			return false;
		}

		if (filters.facilityId !== null && !staffMember.facilityIds.includes(filters.facilityId)) {
			return false;
		}

		return true;
	});
};

export default filterStaffMembers;
